import React from 'react';
import {stopFocusOnClick} from 'epic-ue-shared';
import styled from 'styled-components';
import {TagPill} from '../tagpill';

export const TagPills = styled.div`
    position: relative;
    z-index: 1;
    display: flex;
    flex-wrap: wrap;
    min-height: 32px;
    font-size: 14px;

    .tag-pill {
        margin-top: 5px;
        background-color: ${(p) => p.theme.palette.neutral.pearl};
        div {
            color: ${(p) => p.theme.palette.common.black};
        }
    }
`;

interface Props {
    selectedFilters: any;
    removeFilter: (e, filterLabel, value, isChecked) => void;
    onRemoveTag?: (e, filterLabel, value, isChecked) => void;
}

export const CurrentFilterTags = ({
    selectedFilters,
    removeFilter,
    onRemoveTag
}: Props): JSX.Element => {
    return (
        <TagPills>
            {Object.keys(selectedFilters).map((filterLabel, keyIndex) => {
                if (filterLabel === 'page') return;
                return selectedFilters[filterLabel].map((filterValue) => {
                    return (
                        <div
                            role="button"
                            tabIndex={keyIndex}
                            onClick={(e) => {
                                removeFilter(e, filterLabel, filterValue, false);
                                if (typeof onRemoveTag === 'function') {
                                    onRemoveTag(e, filterLabel, filterValue, false);
                                }
                            }}
                            onMouseDown={stopFocusOnClick}
                            key={filterValue}>
                            <TagPill label={filterValue} />
                        </div>
                    );
                });
            })}
        </TagPills>
    );
};
